import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './src/App.vue'
import '@/assets/css/main.css'
import * as Sentry from '@sentry/vue'

const pinia = createPinia()
const app = createApp(App)

Sentry.init({
    app,
    dsn: 'https://42913b9a3acdf148d6c5bc81b5996778@o4506185066610688.ingest.sentry.io/4506201644924928',
    integrations: [
        new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
        }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})

app.use(pinia)
app.mount('#wr_checkout_app')